import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Enum from './Enum'
import DataType from './DataType'
import { primitives } from '../../helpers/helpers'

const isEnumArray = (enums, field) => {
	if (!field.isArray) {
		return false
	}

	if (!primitives.includes(field.type) && enums[field.type]) {
		return true
	}
}

// Presentational Component
const Property = ({ field, enums }) => {
	return (
		<div className="argument">
			<div className="primary">
				<span className="name">{field.name}</span>

				<DataType field={field} />

				{field.required && <span className="required">required</span>}
			</div>

			<div className="details">
				{field.summary}

				{field.notes && (
					<span
						className="notes"
						dangerouslySetInnerHTML={{ __html: `Notes: ${field.notes}` }}
					></span>
				)}

				{(field.isEnum || isEnumArray(enums, field)) && <Enum type={field.type} />}

				{field.defaultValue && (
					<span className="defaultValue notes">Default Value: {field.defaultValue}</span>
				)}

				{field.metadata && field.metadata.max && (
					<span className="maxValue notes">Maximum Value: {field.metadata.max}</span>
				)}
			</div>
		</div>
	)
}

const mapStateToProps = (state, ownProps) => {
	return {
		enums: state.api.enums,
	}
}

Property.propTypes = {
	field: PropTypes.object.isRequired,
	enums: PropTypes.object.isRequired,
}

export default connect(mapStateToProps)(Property)



// WEBPACK FOOTER //
// ./src/components/api/Property.js